export default __webpack_public_path__ + "static/media/annie.c0f6b1ce.png";